import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "msisdn",
  "account_number",
  "date_activated",
  "last_updated",
];

const ClientSimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    columnsFactory={(ctx) => simInfoColumns({ ...ctx, showAccountNumber: true, showDateActivated: true })}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
  />
);

export default ClientSimInfoBatch;
